'use client';

import { PropsWithChildren } from 'react';
import GraphQLProvider from '@/providers/GraphQLProvider';

export default function PublicLayout({ children }: PropsWithChildren) {
  return <GraphQLProvider>{children}</GraphQLProvider>;
}
